import React from "react";
import { css, cx } from "react-emotion";
import moment from "moment";
import { observer } from "mobx-react";
import { DateRangePicker } from "react-dates";
import Button from "components/Button";
import "react-dates/lib/css/_datepicker.css";
// import styles from "./"css"";

moment.locale("de");

class InputDate extends React.Component {
  state = { focusedInput: null, date: null, focus: false, rangeStart: null, rangeEnd: null, editing: false };

  componentDidMount() {
    const { mountWithFocus } = this.props;
    if (mountWithFocus) this.input.focus();
  }

  clear() {
    const { multipleDates = false } = this.props;
    if (multipleDates) {
      this.setState({ rangeStart: null, rangeEnd: null, editing: false });
    }
  }

  render() {
    const { emStyles } = this;
    const {
      store,
      id,
      label,
      inputWidth = "",
      labelWidth = "",
      formGroupAdd = [],
      // options,
      name,
      inputRef,
      // placeholder,
      onChange,
      // onKeyPress,
      // type,
      allowPastDates = false,
      animatedLabel = true,
      startDatePlaceholderText = "Datum",
      endDatePlaceholderText = "Datum",
      customInputIcon,
      customCloseIcon,
      customArrowIcon = <span className={"dateRangeSeparator"}> — </span>,
      startDateField = "startDate",
      endDateField = "endDate",
      multipleDates = false,
      openDirection = "down",
      onClose,
      withPortal = false,
      withFullScreenPortal = false,
    } = this.props;

    const { focus, rangeStart, rangeEnd, editing } = this.state;
    const value = (store && store.data && store.get(name)) || { [startDateField]: null, [endDateField]: null };

    let sDate;
    let eDate;

    let startName;
    let endName;

    let multipleDatesRaw = [];

    if (multipleDates) {
      const datesString = store && store.data && store.get(name);
      multipleDatesRaw = (datesString && JSON.parse(datesString)) || [];
      startName = name;
      endName = name;
      sDate = rangeStart ? moment(rangeStart) : null;
      eDate = rangeStart && rangeEnd ? moment(rangeEnd) : null; // workaround for DateRangePicker wrong order of calls
    } else {
      startName = name ? `${name}.${startDateField}` : startDateField;
      endName = name ? `${name}.${endDateField}` : endDateField;

      const startDateRaw = store && store.data && store.get(startName);
      const endDateRaw = store && store.data && store.get(endName);

      sDate = startDateRaw ? moment(startDateRaw) : null;
      eDate = endDateRaw ? moment(endDateRaw) : null;
    }

    const animatedLabelUp = animatedLabel && (focus || !!value);

    let smallDevice = window.matchMedia("(max-width: 768px)").matches;
    let orientation = smallDevice ? "vertical" : "horizontal";

    if (withFullScreenPortal && !window.matchMedia("(max-width: 768px)").matches) {
      smallDevice = true;
      orientation = "horizontal";
    }

    return (
      <div
        ref={() => {
          inputRef && inputRef(this);
        }}
        className={cx([
          "inputDateRoot",
          "inputDateRangeRoot",
          animatedLabel ? "placeholderToLabel" : "",
          focus ? "focus" : "",
          emStyles.root,
        ])}
      >
        {label && (
          <label
            htmlFor={id}
            onClick={() => this.input.focus()}
            className={["control-label", labelWidth, animatedLabelUp ? "labelActive" : "labelUnactive"].join(" ")}
          >
            <span className={"labelText"}>{label || name}</span>
            <span className={"labelBackground"} />
          </label>
        )}

        <div className={inputWidth}>
          <DateRangePicker
            withPortal={withPortal}
            showClearDates
            displayFormat={() => "DD.MM.YYYY"}
            isOutsideRange={() => allowPastDates}
            startDatePlaceholderText={startDatePlaceholderText}
            endDatePlaceholderText={endDatePlaceholderText}
            hideKeyboardShortcutsPanel
            withFullScreenPortal={smallDevice}
            customInputIcon={customInputIcon}
            customCloseIcon={customCloseIcon}
            customArrowIcon={customArrowIcon}
            orientation={orientation}
            startDate={sDate}
            endDate={eDate}
            openDirection={openDirection}
            onDatesChange={({ startDate, endDate }) => {
              if (multipleDates) {
                if (startDate) {
                  this.setState({ rangeStart: startDate });
                }
                if (endDate) {
                  this.setState({ rangeEnd: endDate });
                }
                if (startDate && endDate) {
                  if (!editing) {
                    this.setState({ editing: true });
                    multipleDatesRaw.push({ from: startDate.format("YYYY-MM-DD"), to: endDate.format("YYYY-MM-DD") });
                  } else {
                    multipleDatesRaw[multipleDatesRaw.length - 1] = {
                      from: startDate.format("YYYY-MM-DD"),
                      to: endDate.format("YYYY-MM-DD"),
                    };
                  }
                  const datesString = JSON.stringify(multipleDatesRaw);
                  onChange({
                    target: {
                      name: startName,
                      value: datesString,
                    },
                  });
                }
              } else {
                onChange({
                  target: {
                    name: startName,
                    value: startDate ? startDate.format("YYYY-MM-DD") : "",
                  },
                });
                onChange({
                  target: {
                    name: endName,
                    value: endDate ? endDate.format("YYYY-MM-DD") : "",
                  },
                });
              }
            }} // PropTypes.func.isRequired,
            focusedInput={this.state.focusedInput} // PropTypes.oneOf([START_DATE, END_DATE]) or null,
            onFocusChange={focusedInput => this.setState({ focusedInput })} // PropTypes.func.isRequired,
            renderCalendarInfo={() => (
              <div className="text-right" style={{ paddingBottom: 10, paddingRight: 10 }}>
                <Button size="small" onClick={() => this.setState({ ...this.state, focusedInput: null })}>
                  Anwenden
                </Button>
              </div>
            )}
            onClose={() => onClose && onClose({ startDate: sDate, endDate: eDate })}
          />
        </div>

        {formGroupAdd}

        {store && store.errors && store.errors[name] && (
          <p className={"error"}>
            <small>{store.errors[name]}</small>
          </p>
        )}
      </div>
    );
  }

  emStyles = {
    root: css`
      .DateInput {
        border: 0 !important;
        padding-bottom: 0px;
        top: 0px;
        padding-left: 0px;
        input[type="text"].DateInput_input {
          padding: 0 10px 0 10px;
          height: 34px;
          max-width: 135px;
        }
      }
      .DateRangePickerInput_clearDates {
        padding: 7px 10px;
        margin: 0px;
      }
    `,
  };
}

export default observer(InputDate);
